import type { ReactNode } from "react";

import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";

type StepCardProps = Readonly<{
  /** The key of the step. The heading has the id `step-<step>-title`: the wizard moves focus there when the step changes. */
  step: string;
  title: string;
  busy?: boolean;
  children: ReactNode;
}>;

/** The card of one wizard step, built from the kit `Card`. The heading takes focus by code (`tabIndex={-1}`). */
export function StepCard({ step, title, busy, children }: StepCardProps) {
  return (
    <section aria-labelledby={`step-${step}-title`} aria-busy={busy} className="min-w-0">
      <Card>
        <CardHeader>
          <CardTitle id={`step-${step}-title`} tabIndex={-1}>
            {title}
          </CardTitle>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </section>
  );
}
